export default "__VITE_ASSET__Cqkqjx2x__"